module.exports = __webpack_public_path__ + "static/img/036 3.ac1ee8b7.jpg";